import { useCallback } from 'react';
import { getLoginPageUrl } from '../getAuthenticationUrl';
import { logout } from './logout';
import { useClearCache } from './useClearCache';

export const useLogout = () => {
  const clearCache = useClearCache();
  return useCallback(async () => {
    try {
      const response = await logout();
      // A 401 means the session had already expired, so the user is logged out either way.
      if (!response.isSuccess && !response.isUnauthorized) throw new Error('Failed to log out');
      clearCache();
      const loginUrl = getLoginPageUrl();
      window.location.assign(loginUrl);
    } catch (error) {
      console.error(error);
    }
  }, [clearCache]);
};
